// Drop-in replacement for the abandoned angular5-csv package.
// Output matches what Angular5Csv produced with the options used across the app
// (BOM, unquoted header row, quoted strings, null -> empty string).
const EOL = "\r\n";
const BOM = "﻿";

function formatValue(value: any): any {
  if (typeof value === "string") {
    return `"${value.replace(/"/g, '""')}"`;
  }
  if (value === null) {
    return "";
  }
  return value;
}

export function downloadCsv(data: any[], fileName: string, headers: string[]): string {
  let csv = BOM;
  if (headers.length > 0) {
    csv += headers.join(",") + EOL;
  }
  for (const row of data) {
    const values = [];
    for (const key in row) {
      values.push(formatValue(row[key]));
    }
    csv += values.join(",") + EOL;
  }

  const blob = new Blob([csv], { type: "text/csv;charset=utf8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("visibility", "hidden");
  link.download = fileName.replace(/ /g, "_") + ".csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
  return csv;
}
